interface ArrayProps {
    key?: number;
}

type ArrayPropsT<T> = (ArrayProps & {[index: string]: T});

export function createArrayWithProps<T>(startIteration: number, endIteration: number, prop: [string, T]): ArrayPropsT<T>[] {
    const arr: ArrayPropsT<T>[] = [];

    if (startIteration && endIteration && prop) {
        for (let i = startIteration; i <= endIteration; i++) {
            const a: ArrayPropsT<T> = { key: i } as ArrayPropsT<T>;
            a[prop[0]] = prop[1] as any;
            arr.push(a);
        }
    }

    return arr;
}
